import { Container } from "./style";

export const WeatherCityItem = ({ url, name }) => {
  return (
    <Container className="each">
      <h3><a href={url}>{name}</a></h3>
    </Container>
  );
};
